import { FieldProcessStepper, type ProcessStep } from "../../../shared/components/FieldProcessStepper";

/** Office Mode B strip for first-token: Submit → Approve → Deliver */
export function KeyApprovalProcessStrip({
  activeStep,
}: {
  /** 0 Submit (queue), 1 Approve, 2 Deliver */
  activeStep: 0 | 1 | 2;
}) {
  const labels = ["Submit", "Approve", "Deliver"];
  const steps: ProcessStep[] = labels.map((label, index) => ({
    label,
    state: index < activeStep ? "done" : index === activeStep ? "current" : "todo",
  }));
  return (
    <FieldProcessStepper
      variant="panel"
      ariaLabel="Key approval process"
      steps={steps}
    />
  );
}
